import React, { useState } from 'react';
import { PixelBox, PixelButton, PixelContainer } from '../ui/PixelComponents';
import { useAuth } from '../../context/AuthContext';

interface RecoveryFormProps {
  onSwitchToLogin: () => void;
}

export const RecoveryForm: React.FC<RecoveryFormProps> = ({ onSwitchToLogin }) => {
  const [userNumber, setUserNumber] = useState('');
  const [recoveryWords, setRecoveryWords] = useState('');
  const { recover, isLoading, error } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const words = recoveryWords.toLowerCase().trim().split(/\s+/);

    if (userNumber.length !== 8 || words.length !== 10) {
      return;
    }

    try {
      await recover(userNumber, words);
    } catch (error) {}
  };

  return (
    <div
      style={{
        width: '90%',
        maxWidth: '420px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        padding: '20px',
      }}
    >
      {/* Логотип */}
      <div
        style={{
          alignSelf: 'center',
          marginBottom: '20px',
        }}
      >
        <div
          style={{
            backgroundColor: '#000000',
            color: '#FFFFFF',
            borderColor: '#000000',
          }}
        >
          <div
            style={{
              fontSize: '32px',
              fontWeight: 'bold',
              padding: '4px 16px',
            }}
          >
            Ё
          </div>
        </div>
      </div>

      {/* Основная форма */}
      <PixelContainer
        style={{
          padding: '0',
          backgroundColor: '#fff',
        }}
      >
        {/* Контент формы */}
        <div
          style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingTop: '8px',
            paddingBottom: '16px',
          }}
        >
          {/* Заголовок с полосками */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#fff',
            }}
          >
            <div
              style={{
                flex: 1,
                height: '3px',
                backgroundColor: '#FFF',
                marginLeft: '8px',
              }}
            ></div>
            <div
              style={{
                padding: '8px 16px',
                fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                fontSize: '14px',
                fontWeight: 'bold',
                letterSpacing: '1px',
              }}
            >
              КЛЮЧ
            </div>
            <div
              style={{
                flex: 1,
                height: '3px',
                backgroundColor: '#FFF',
                marginRight: '8px',
              }}
            ></div>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <div
                style={{
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: '10px',
                  marginBottom: '6px',
                  color: '#666',
                  textTransform: 'uppercase',
                }}
              >
                Вот твой номер
              </div>
              <PixelContainer
                style={{
                  padding: '0',
                  backgroundColor: '#F0F0F0',
                  width: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <input
                  type='text'
                  maxLength={8}
                  placeholder='00000000'
                  value={userNumber}
                  onChange={(e) => setUserNumber(e.target.value.replace(/\D/g, ''))}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: 'none',
                    fontFamily: 'Roboto Mono, monospace',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    letterSpacing: '2px',
                    backgroundColor: 'transparent',
                    textAlign: 'center',
                    outline: 'none',
                    boxSizing: 'border-box',
                  }}
                />
              </PixelContainer>
            </div>

            <div
              style={{
                marginBottom: '20px',
                padding: 0,
                width: '100%',
                backgroundColor: 'transparent',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: '10px',
                  marginBottom: '6px',
                  color: '#666',
                  textTransform: 'uppercase',
                  width: '100%',
                }}
              >
                Ключ восстановления
              </div>
              <PixelContainer
                style={{
                  padding: '10px',
                  backgroundColor: '#F0F0F0',
                  boxSizing: 'border-box',
                  width: '100%',
                  flex: 1,
                }}
              >
                <textarea
                  placeholder='десять слов через пробел'
                  value={recoveryWords}
                  onChange={(e) => setRecoveryWords(e.target.value.toLowerCase())}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: 'none',
                    fontFamily: 'Roboto Mono, monospace',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    letterSpacing: '2px',
                    backgroundColor: 'transparent',
                    textAlign: 'center',
                    minHeight: '80px',
                    resize: 'none',
                    lineHeight: '1.4',
                    outline: 'none',
                    boxSizing: 'border-box',
                  }}
                />
              </PixelContainer>
              <div
                style={{
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: '9px',
                  color: '#666',
                  marginTop: '14px',
                  textAlign: 'center',
                }}
              >
                ВПИШИ ФРАЗУ ЧЕРЕЗ ПРОБЕЛ
              </div>
            </div>

            {error && (
              <div
                style={{
                  color: '#FF0000',
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: '10px',
                  marginBottom: '12px',
                  textAlign: 'center',
                }}
              >
                {error}
              </div>
            )}

            <div
              style={{
                textAlign: 'center',
                marginBottom: '12px',
              }}
            >
              <button
                type='button'
                onClick={onSwitchToLogin}
                style={{
                  background: 'none',
                  border: 'none',
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: '10px',
                  color: '#666',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  textTransform: 'uppercase',
                }}
              >
                Вспомнил, войти
              </button>
            </div>
          </form>
        </div>
      </PixelContainer>

      {/* Кнопка действия */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <PixelButton
          backgroundColor='#C0C0C0'
          borderColor='#000000'
          shadowColor='#808080'
          onClick={handleSubmit}
          disabled={
            userNumber.length !== 8 ||
            recoveryWords
              .trim()
              .split(/\s+/)
              .filter((w) => w).length !== 10 ||
            isLoading
          }
          size='medium'
          style={{
            padding: '12px 24px',
            minWidth: '180px',
          }}
        >
          <div
            style={{
              fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
              fontSize: '16px',
              fontWeight: 'bold',
              letterSpacing: '1px',
            }}
          >
            {isLoading ? 'ПОЛУЧАЮ...' : 'НОВЫЙ КОД'}
          </div>
        </PixelButton>
      </div>
    </div>
  );
};
